import { render } from "./EditExpensesPage.vue?vue&type=template&id=7a7369cc&ts=true"
import script from "./EditExpensesPage.vue?vue&type=script&lang=ts"
export * from "./EditExpensesPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__